import type { AgentStatus, IAgentsCategorized } from '@/store/types';

const baseCategorizedAgents: () => IAgentsCategorized = () => ({
  termination: [],
  suspension: [],
  ended: [],
  active: [],
  resignation: [],
  reinstatement: [],
});

const IGNORED_AGENT_STATUSES: readonly AgentStatus[] = Object.freeze(['ended']);

export { baseCategorizedAgents, IGNORED_AGENT_STATUSES };
